<template>

  <div v-loading="allLoading"
       class="layout-container flex justify-center"
       :class="{'column':navPos === 'top' || navPos  === 'bottom','boxed':boxed,'footer-above':footer === 'above','content-only':!navPos}">

    <vertical-nav :position="navPos"
                  :collapse-nav="collapseNav"
                  :open-sidebar.sync="openSidebar"
                  @collapse-nav-toggle="collapseNav = !collapseNav"
                  @push-page="closeSidebar"
                  v-if="navPos === 'left'" />

    <div class="container flex column box grow">
      <div class="header"
           v-if="toolbar === 'top'">
        <Toolbar @toggle-sidebar="openSidebar = !openSidebar"
                 :menu-burger="navPos" />
      </div>
      <horizontal-nav :position="navPos"
                      @push-page="closeSidebar"
                      v-if="navPos === 'top'" />
      <div class="header"
           v-if="toolbar === 'bottom'">
        <Toolbar @toggle-sidebar="openSidebar = !openSidebar"
                 :menu-burger="navPos" />
      </div>

      <div class="main box grow flex"
           v-if='!allLoading'>
        <span class="main-out-border--top-left"
              v-if="roundedCorners"></span>
        <span class="main-out-border--top-right"
              v-if="roundedCorners"></span>
        <span class="main-out-border--bottom-left"
              v-if="roundedCorners"></span>
        <span class="main-out-border--bottom-right"
              v-if="roundedCorners"></span>
        <transition :name="viewAnimation"
                    mode="out-in">
          <router-view class="view box grow" />
        </transition>
      </div>
      <horizontal-nav :position="navPos"
                      @push-page="closeSidebar"
                      v-if="navPos === 'bottom'"
                      style="margin-bottom:0;" />

      <Footer v-if="footer === 'below' && !allLoading"
              :position="footer" />
    </div>

    <vertical-nav :position="navPos"
                  :collapse-nav="collapseNav"
                  :open-sidebar.sync="openSidebar"
                  @collapse-nav-toggle="collapseNav = !collapseNav"
                  @push-page="closeSidebar"
                  v-if="navPos === 'right'" />

    <Footer v-if="footer === 'above'"
            :position="footer" />
    <el-dialog class="el--dialog-width"
               :visible.sync="this.getLogoutDialog"
               width="100%"
               :modal="true"
               :show-close="false"
               :close-on-click-modal="false">
      <el-row>
        <el-col class="text-center">
          <img src="../public/tips.png">
        </el-col>
      </el-row>
      <el-row>
        <el-col class="text-center">
          <h2>{{$t('logout.isSure')}}</h2>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col class="text-center">
          <el-button class="el-button-sub font"
                     type="primary"
                     @click="logout">{{$t('common.yes')}}</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col class="text-center">
          <el-button class="el-button-sub font"
                     @click="closeLogoutDialog">{{$t('common.no')}}</el-button>
        </el-col>
      </el-row>

    </el-dialog>
    <div class="dialog-wrap">
      <el-dialog :visible.sync="dialogVisible"
                 :show-close="false"
                 :close-on-press-escape="false"
                 :before-close="handleClose"
                 width="20%"
                 center>
        <userNotes @returnLogin="returnLogin"
                    :idType="idType"
                   @confirm="confirm"></userNotes>
      </el-dialog>
    </div>
    <!-- 客户尽职审查弹框 -->
    <div class="cdd-dialog">
      <el-dialog
        top="25vh"
        title=""
        :visible.sync="cddDialogVisible"
        width="25%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
         <div>
           <div class="font-m-pf-deep-bule cdd-context-title">
             {{$t('home.cdd.title')}}
           </div>
           <div class="font-sxx-pf-black cdd-context">
            <p> {{$t('home.cdd.context1')}}</p>
            <p>{{$t('home.cdd.context2')}}</p>
            <p>{{$t('home.cdd.context3')}}</p>
           </div>

         </div>

        <div slot="footer" class="cdd-dialog-button-box">
          <el-button class="m-10 button-w-h-250-56" type="primary" @click="confirmCdd">{{$t('common.yes')}}</el-button>
          <el-button class="m-10 button-w-h-250-56" @click="closeCddDialog">{{$t('common.no')}}</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 客户尽职审查，资料不同弹框 -->
    <div class="cdd-file-difference-dialog">
      <el-dialog
        top="25vh"
        title=""
        :visible.sync="cddfdDialogVisible"
        width="25%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
         <div class="cdd-context-title file-difference-context font-sxx-pf-black">
           {{$t('home.cdd.fileDiffContext')}}
         </div>
        <div slot="footer" class="cdd-dialog-button-box">
          <el-button class="m-10 button-w-h-250-56" type="primary" @click="confirmCddFd">{{$t('common.ok')}}</el-button>
          <el-button class="m-10 button-w-h-250-56" @click="closeCddfdDialog">{{$t('common.cancel')}}</el-button>
        </div>

      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { detect } from 'detect-browser'
import userNotes from './components/userNotes'
import HorizontalNav from '@/core/horizontal-nav.vue'
import VerticalNav from '@/core/vertical-nav.vue'
import Toolbar from '@/core/toolbar.vue'
import Footer from '@/core/footer.vue'
import SecurityService from '@/js/util/SecurityService.js'
// import Cookies from 'js-cookie'
import pdfText from '@/js/openingAgreement.js'
// import proxyApi from '@/api/proxy-api'
import { getUserInfo, customerAgreement } from '@/api/v2/user'
import { submitDueDiligence, logout } from '@/api/v2/deposit'

const browser = detect()

export default {
  name: 'App',
  components: {
    HorizontalNav,
    VerticalNav,
    Toolbar,
    Footer,
    userNotes
  },
  created() {
    if (browser.name) {
      document.getElementsByTagName('html')[0].classList.add(browser.name)
    }
  },
  async mounted() {
    if (localStorage.getItem('access_token')) {
      this.initData()
    }

    this.resizeOpenNav()
    window.addEventListener('resize', this.resizeOpenNav)
    // 设置onlineChatFn()方法延迟１０秒执行
    var timeout
    clearTimeout(timeout)
  },
  data() {
    return {
      collapseNav: false,
      openSidebar: false,
      innerWidth: 0,
      oAuth: new SecurityService(),
      allLoading: false,
      version: 'sprint33',
      checked: false,
      pdfText: pdfText,
      // cddDialogVisible: true, // 客户尽职审查dialog
      cddfdDialogVisible: false, // 客户尽职审查资料不相同dialog
      isDueDiligence: '',
      fileDiff: 'IDENTICAL',
      accountId: '',
      clientId: '',
      loginCode: '',
      idType: ''
    }
  },
  watch: {
    getAccessToken: function(newVal) {
      if (newVal) {
        this.initData(newVal)
      }
    }
  },
  // create () {
  //   this.initData(newVal)
  // },

  computed: {
    ...mapGetters([
      'getLogoutDialog',
      'getIdToken',
      'getAccessToken',
      'getAccountInfo',
      'getClientProfile',
      'getUser',
      'getAccountOpeningAgreement'
    ]),
    ...mapState(['user']),
    accountNumber() {
      return this.getAccountInfo.accountNumber
    },
    navPos() {
      if (
        this.innerWidth <= 768 &&
        (this.$store.getters.navPos === 'top' ||
          this.$store.getters.navPos === 'bottom')
      ) {
        return 'left'
      }
      return this.$store.getters.navPos
    },
    toolbar() {
      return this.$store.getters.toolbar
    },
    footer() {
      return this.$store.getters.footer
    },
    boxed() {
      return this.$store.getters.boxed
    },
    roundedCorners() {
      return this.$store.getters.roundedCorners
    },
    viewAnimation() {
      return this.$store.getters.viewAnimation || 'none'
    },
    isLogged() {
      return this.$store.getters.isLogged
    },
    splashScreen() {
      return this.$store.getters.splashScreen
    },
    dialogVisible: {
      get() {
        // console.log(
        //   'this.getAccountOpeningAgreement>>>>>>>>>>>',
        //   this.getAccountOpeningAgreement,
        //   this.getAccountInfo
        // )
        if (!this.getAccountInfo) {
          return false
        }
        if (this.getAccountOpeningAgreement !== 'AGREE') {
          return true
        }
        return false
      },
      set() {}
    },
    cddDialogVisible() {
      let flag = false
      if (this.getAccountOpeningAgreement === false) {
        return flag
      }
      // 如果有尽职审查，隐藏客户声明
      if (this.dialogVisible) {
        return false
      }
      if (this.isDueDiligence) {
        flag = true
      }
      return flag
    }
  },
  methods: {
    async confirm(isChecked) {
      await this.updateAgreementStatus()
    },
    // async getTokenByCode (code) {
    //  let params = {
    //     grant_type: 'authorization_code',
    //     code: code,
    //     redirect_uri: 'https://test1.local:8080/home'
    //   }
    //   let result = await commonRequest.getTokenByCode(params)
    //   let data = result.data ? result.data : {}
    //   if (data.access_token) {
    //     this.$router.push('/home')
    //     localStorage.setItem('access_token', data.access_token)
    //   }

    // // localStorage.setItem('expire_time', data.access_token)
    //   return data
    // },
    async updateAgreementStatus() {
      try {
        // let options = {
        //   id: this.getAccountInfo.clientId,
        //   accountOpeningAgreement: true
        // }
        // let res = await this.$store.dispatch('updateAgreementStatus', options)
        this.loading = true
        let params = {
          type: 'CUSTOMER_STATEMENT'
        }
        let res = await customerAgreement(params)
        this.dialogVisible = false
        if (res.code === 200) {
          this.$store.dispatch('setAccountOpeningAgreement', 'AGREE')
          if (!this.isDueDiligence) {
            this.cddDialogVisible = true
          }
        }
        this.loading = false
      } catch (error) {
        this.dialogVisible = false
        this.loading = false
        this.$store.dispatch('setAccountOpeningAgreement', 'AGREE')
        console.log('setAgreementStatus---err', error)
      }
    },
    returnLogin() {
      // this.oAuth.signOut()
      this.$store.commit('setAccessToken', '')
      localStorage.clear()
      window.location.href = `${
        process.env.VUE_APP_AUTH
      }/login.html?client_id=account_center&client_secret=abcd&redirect_uri=${
        process.env.VUE_APP_CALLBACKURL
      }&state=sdfsfs&scope=basic&response_type=code&signup_uri=${
        process.env.VUE_APP_SIGNUP_URI
      }`
    },
    handleClose(done) {
      if (this.accountOpeningAgreement === true) {
        done()
      } else {
        return false
      }
    },
    resizeOpenNav() {
      this.innerWidth = window.innerWidth
      if (window.innerWidth <= 768) {
        this.collapseNav = false
      }
    },
    closeSidebar() {
      this.openSidebar = false
    },
    closeLogoutDialog() {
      this.$store.commit('setLogoutDialog', false)
    },
    async logout() {
      // // 清除验证码cookie TODO 验证码验证改成后端验证后这一段要删除
      // let phoneNum = this.$store.state.user.profile.phone_number
      // let userPhoneNumKey = 'phone_number' + this.$store.state.user.profile.phone_number
      // if (phoneNum.substring(0, 2) == '86') {
      //   Cookies.remove(userPhoneNumKey)
      // }

      // // clear LocalStorage call OAuth logout
      // this.oAuth.signOut()
      let res = await logout()
      if (res && res.code === 200) {
        this.$store.commit('setAccessToken', '')
        localStorage.clear()
        sessionStorage.clear()
        window.location.href = `${
          process.env.VUE_APP_AUTH
        }/login.html?client_id=account_center&client_secret=abcd&redirect_uri=${
          process.env.VUE_APP_CALLBACKURL
        }&state=sdfsfs&scope=basic&response_type=code&signup_uri=${
          process.env.VUE_APP_SIGNUP_URI
        }`
      } else {
        this.$message.error('网络错误，请稍后重试')
      }
    },
    async initData() {
      try {
        this.allLoading = true

        // let profile = await this.$getProfile()
        // let sub = profile.sub
        // let obj = {
        //   params: {
        //     proxyUrl: `client/client-portal-init-data/${sub}`
        //   }
        // }
        let result = await getUserInfo()
        let {
          data: { tradingAccountList, user }
        } = result
        let allTradingAccountList = JSON.parse(
          JSON.stringify(tradingAccountList)
        )
        tradingAccountList = tradingAccountList.filter(item => {
          return item.status === 'OPEN'
        })
        let filterSPTradingAccountList = tradingAccountList

        // 过滤sp账号，除了入金支持sp，其他均不支持
        if (user.isSPAccount === 'Y') {
          filterSPTradingAccountList = (tradingAccountList || []).filter(
            (items) => {
              return items.tradeChannel !== 'SP'
            }
          )
        }
        this.isDueDiligence = user.isNeedDueDiligence
        this.idType = user.idType
        // this.accountId = accountInfo._id
        // this.clientId = userInfo._id
        // 设置用户基本信息

        // 开户状态同步失败，兼容处理，后面去掉
        // if (tradingAccountList.length) {
        //   user.isAccountOpening = true
        // }

        // 是否开户
        this.$store.commit('setAccountOpening', user.isAccountOpening)

        this.$store.dispatch('getUserInfoByidpUserId', user)
        // 设置用户阅读用户须知状态

        this.$store.dispatch(
          'setAccountOpeningAgreement',
          user.customerStatement
        )
        // 设置账户信息
        console.log(
          tradingAccountList,
          allTradingAccountList,
          'allTradingAccountList'
        )
        this.$store.commit('setAccountInfo', tradingAccountList || [])
        this.$store.commit('setAllAccountInfo', allTradingAccountList || [])
        this.$store.commit('setUserInfo', user || {})
        this.$store.commit('setFilterSPTradingAccountList', filterSPTradingAccountList || [])

        // 根据用户地区设置默认语言 当手动切换简繁体后或者从pc客户端进入就不再判断客户地区
        // if (sessionStorage.getItem('isChange') !== 'yes' && localStorage.getItem('source') !== 'pc') {
        //   if (user.issuingCountry !== 'CHN') {
        //     sessionStorage.setItem('language', 'hk')
        //     this.$i18n.locale = 'hk'
        //     this.$store.commit('setCurLang', 'hk')
        //   } else {
        //     sessionStorage.setItem('language', 'cn')
        //     this.$i18n.locale = 'cn'
        //     this.$store.commit('setCurLang', 'cn')
        //   }
        // }
        if (sessionStorage.getItem('language')) {
          this.$i18n.locale = sessionStorage.getItem('language')
          this.$store.commit('setCurLang', sessionStorage.getItem('language'))
        }

        // 设置黄金账号配置
        // this.$store.dispatch('getSysconfig', setBullionClient)
        // 初始化账户余额信息
        // this.getAccountType()
      } catch (e) {
        e.msg && this.$message.error(e.msg)
        console.log('initData--err', e)
      } finally {
        this.allLoading = false
      }
    },
    // 这一部分好像没用到
    async getAccountType() {
      if (this.getAccountOpeningAgreement) {
        let tradeAccountList = this.getAccountInfo
        let options = tradeAccountList.map(item => {
          return {
            accountId: this.accountId,
            tradeAccountNumber: item.tradeAccountNumber,
            tradeAccountType: item.tradeAccountType
          }
        })
        // TODO 这一块是干嘛的？为什么要在app.vue获取余额？
        await this.$store.dispatch('getAccountBalance', {
          balanceParams: options
        })
      }
    },
    closeCddDialog() {
      this.isDueDiligence = true
      this.cddfdDialogVisible = true
      // this.fileDiff = 'INCONSISTENT'
    },
    closeCddfdDialog() {
      this.cddfdDialogVisible = false
      // this.isDueDiligence = false
    },
    confirmCddFd() {
      this.cddfdDialogVisible = false
      this.isDueDiligence = true
      this.fileDiff = 'INCONSISTENT'
      this.confirmCdd()
    },
    async confirmCdd() {
      try {
        this.loading = true
        // let obj = {
        //   proxyUrl: `client/dueDiligence/create`,
        //   accountId: this.accountId,
        //   clientId: this.clientId,
        //   fileDiff: this.fileDiff,
        //   source: 'cp'
        // }
        // let { code } = await proxyApi.proxyPost(obj)
        // this.isDueDiligence = true
        // this.cddfdDialogVisible = false
        // this.loading = false
        // if (code === 200) {
        //   this.$message({
        //     message: this.$t('errorTips.doSuccess'),
        //     type: 'success'
        //   })
        // }
        if (this.cddDialogVisible) {
          let params = {
            fileDiff: this.fileDiff,
            submitSource: 'CP_WEB'
          }
          let res = await submitDueDiligence(params)
          this.isDueDiligence = true
          this.cddfdDialogVisible = false
          if (res.code === 200) {
            this.$message({
              message: this.$t('errorTips.doSuccess'),
              type: 'success'
            })
            this.isDueDiligence = false
          }
          this.loading = false
        } else {
          let params = {
            type: 'CUSTOMER_STATEMENT'
          }
          let res = await customerAgreement(params)
          if (res.code === 200) {
            this.$store.dispatch('setAccountOpeningAgreement', 'AGREE')
            // let stringifyObj = JSON.stringify({ agreement: 'agreement' })
            // const { WebViewBridge, ReactNativeWebView } = window
            // if (WebViewBridge) {
            //   // WebViewBridge
            //   WebViewBridge.send(stringifyObj)
            // }
            // if (ReactNativeWebView) {
            //   // android专用
            //   window.ReactNativeWebView.postMessage(stringifyObj)
            // }
          }
        }
      } catch (error) {
        this.loading = false
        this.cddfdDialogVisible = false
        this.isDueDiligence = true
        this.$message.error(this.$t('errorTips.doError'))
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeOpenNav)
  }
}
</script>

<style lang="scss">
@import './assets/scss/_variables';
@import './assets/scss/_mixins';
.users-notes-container .content .bscroll-vertical-scrollbar {
  right: 12px !important;
}
.layout-container {
  .m-10 {
    margin: 10px !important;
  }
  .button-w-h-250-56 {
    width: 250px;
    height: 56px;
  }
  .dialog-wrap{
    .el-dialog__body{
      padding: 0 30px 50px;
    }
     .el-dialog--center{
      height: auto !important;
    }
  }
  .cdd-dialog,
  .cdd-file-difference-dialog {
    .el-dialog__header {
      padding: 0px !important;
    }
    .el-dialog__body {
      padding: 40px 0 0 0 !important;
    }
    .el-dialog__footer {
      padding-top: 0px !important;
    }
    .cdd-context-title {
      text-align: center;
    }
    .cdd-context {
      padding: 0px 63px;
    }
    .file-difference-context {
      padding: 0px 63px 20px 63px;
    }
    .cdd-dialog-button-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background-color: $background-color;
  // @include bg_color();
  .dialog-content {
    height: 400px;
    overflow-y: hidden;
  }
  .el-dialog--center {
    height: 600px;
  }
  .center {
    text-align: center;
    font-weight: 700;
  }
  .bold {
    font-weight: 700;
  }
  .el--dialog-width {
    max-width: 500px;
    margin: 0 auto;
  }
  .el-button-sub {
    width: 50%;
    height: 100%;
    margin: 10px auto;
    line-height: 20px;
  }
  .font {
    font-family: Muli-Bold;
    font-size: 14px;
    color: #193060;
    letter-spacing: 0.17px;
    text-align: center;
  }
  .container {
    overflow: hidden;

    .header {
      background-color: $header-background-color;
      height: 60px;
      border-bottom: 2px solid #e5e5e5;
    }

    .main {
      overflow: auto;
      // padding: 0 30px;
    }

    .view {
      // padding: 20px;
      padding-bottom: 10px;
      padding-top: 0px;
      box-sizing: border-box;
      transition: all 0.4s cubic-bezier(0.55, 0, 0.1, 1);
      backface-visibility: hidden;
      /*-webkit-perspective: 1000px;*/
    }
    .fade-top-in-out-enter {
      opacity: 0;
      transform: translate(0, 30px);
    }
    .fade-top-in-out-leave-active {
      opacity: 0;
      transform: translate(0, 30px);
    }

    .fade-top-enter {
      opacity: 0;
      transform: translate(0, 30px);
    }
    .fade-top-leave-active {
      opacity: 0;
      transform: translate(0, -30px);
    }

    .fade-bottom-in-out-enter {
      opacity: 0;
      transform: translate(0, -30px);
    }
    .fade-bottom-in-out-leave-active {
      opacity: 0;
      transform: translate(0, -30px);
    }

    .fade-bottom-enter {
      opacity: 0;
      transform: translate(0, -30px);
    }
    .fade-bottom-leave-active {
      opacity: 0;
      transform: translate(0, 30px);
    }

    .fade-left-enter {
      opacity: 0;
      transform: translate(30px, 0);
    }
    .fade-left-leave-active {
      opacity: 0;
      transform: translate(-30px, 0);
    }

    .fade-right-enter {
      opacity: 0;
      transform: translate(-30px, 0);
    }
    .fade-right-leave-active {
      opacity: 0;
      transform: translate(30px, 0);
    }

    .fade-enter {
      opacity: 0;
    }
    .fade-leave-active {
      opacity: 0;
    }

    .main-out-border {
      &--top-left,
      &--top-right {
        background: linear-gradient($background-color, rgba(230, 235, 241, 0));
        height: 16px;
        position: absolute;
        width: 8px;
        z-index: 1;
        top: 4px;
      }
      &--bottom-left,
      &--bottom-right {
        background: linear-gradient(rgba(230, 235, 241, 0), $background-color);
        height: 16px;
        position: absolute;
        width: 8px;
        z-index: 1;
        bottom: 4px;
      }

      &--top-left,
      &--bottom-left {
        left: 42px;

        &::after {
          content: '';
          height: 5px;
          position: absolute;
          right: -4px;
          top: -4px;
          width: 12px;
          box-shadow: 8px 0px 0px 0px $background-color inset;
          border-top-left-radius: 5px;
        }
      }
      &--top-right,
      &--bottom-right {
        right: 42px;

        &::after {
          content: '';
          height: 5px;
          left: -4px;
          position: absolute;
          top: -4px;
          width: 12px;
          box-shadow: -8px 0px 0px 0px $background-color inset;
          border-top-right-radius: 5px;
        }
      }

      &--bottom-left:after {
        border-radius: 0;
        border-bottom-left-radius: 5px;
      }
      &--bottom-right:after {
        border-radius: 0;
        border-bottom-right-radius: 5px;
      }

      &--bottom-left,
      &--bottom-right {
        &::after {
          top: initial;
          bottom: -4px;
        }
      }
    }
  }

  &.boxed {
    max-width: 1300px;
    margin: 0 auto;
    box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.15),
      0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  }

  &.footer-above {
    padding-bottom: 40px;
    position: relative;
  }

  &.content-only {
    .container {
      .main-out-border--top-left,
      .main-out-border--top-right,
      .main-out-border--bottom-left,
      .main-out-border--bottom-right {
        display: none;
      }
    }
  }
}

html:not(.ie) {
  .layout-container {
    .container {
      max-width: 1920px;
    }
  }
}

@media (min-width: 1920px) {
  .layout-container:not(.boxed) {
    &.column {
      .container {
        margin: 0 auto;
      }
    }
  }
}

@media (max-width: 768px) {
  .layout-container {
    .container {
      /*width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;*/

      .header {
        height: 50px;
        background: #fff;
        box-shadow: 0px -20px 10px 20px rgba(0, 0, 0, 0.25);
        margin: 0;
        margin-bottom: 5px;
        z-index: 2018;
        .toggle-sidebar {
          box-shadow: none !important;
        }

        .search-box {
          & > .el-autocomplete {
            box-shadow: none !important;
          }
        }
      }

      .main {
        padding: 0 5px;
      }

      .view {
        max-width: 100%;
        padding: 15px;
        padding-left: 15px;
        padding-right: 15px;
        margin: 0;
      }
      .main-out-border--top-left,
      .main-out-border--top-right,
      .main-out-border--bottom-left,
      .main-out-border--bottom-right {
        display: none;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
